export function returnBaseUrl(ambiente: string, porta?: string): string {
  if (ambiente === 'des') {
    return 'https://des-pgrm.np.estaleiro.serpro.gov.br/';
  } else if (ambiente === 'hom') {
    return 'https://hom-pgrm.estaleiro.serpro.gov.br/';
  } else if (ambiente === 'local') {
    return `http://localhost:${porta ?? '8080'}/`;
  } else {
    return 'https://pgrm.serpro.gov.br';
  }
}

export function returnSCAUrl(ambiente: string): string {
  if (ambiente === 'pro') {
    return 'https://app.anm.gov.br/sca-auth-api';
  } else {
    return 'https://newhmgapp.anm.gov.br/sca-auth-api';
  }
}
